<template>
    <div class="relative bg-wrap-color">
        <template v-if="isPageAllowed">
            <div class="tab-bar relative" v-if="componentName == 'listPage' ">
                <el-tabs value="batch" @tab-click="handleTabClick">
                  <el-tab-pane v-if="pageActionNames.includes('mi_batch_create')" label="批量创建" name="batch"></el-tab-pane>
                    <el-tab-pane v-if="pageActionNames.includes('mi_batch_v2_create')" label=" 批量搭建-自动优化" name="batch_v2"></el-tab-pane>
                </el-tabs>
            </div>
            <div class="bg-color list-wrap">
                <keep-alive :include="keepList">
                    <component
                        :ref="componentName"
                        :is="componentName"
                        :pageName="componentName"
                        :pageFuncNames="pageFuncNames"
                        :pageDimensionNames="pageDimensionNames"
                        :dataId="actionItemId"
                        :id="actionItemId"
                        @changePage="handleChangePage"
                        @clearAlive="clearAlive"
                        :getFormDate="()=>defaultCreteFormData"
                    />
                </keep-alive>
            </div>

        </template>
        <template v-else>
            <NoPermissionInfo style="background-color: #fff;">
                <p>此页面展示小米媒体相关数据内容与广告管理。</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import HomeAPI from '@/api/home.js';
    import listPage from './page/listPage.vue'
    import infoPage from './page/infoPage.vue'
    import configPage from './page/configPage.vue'
    import previewPage from './page/previewPage.vue'
    import {undistributeMixin} from '../../mixins/undistributeMixin';
    export default {
        mixins: [undistributeMixin],
        components: {
            listPage,
            configPage,
            NoPermissionInfo,
            previewPage,
            infoPage,
        },
        data() {
            return {
                componentName: 'listPage',
                isPageAllowed: true,
                dimensionList: [],
                pageFunc: [],
                actionItemId:'',
                defaultCreteFormData: {},
                keepList:['listPage'],
                pageAction:[],
            }
        },
        created() {
            this.getPageAllowAction()
        },
        computed:{
            pageFuncNames() {
                return this.pageFunc.map(item => item.name);
            },
            pageDimensionNames(){
                return this.dimensionList.map(item => item.name);
            },
             pageActionNames() {
                return this.pageAction.map(v=>v.name)
            }
        },
        watch:{
            '$route'(to,from){
                /*处理同路由push不刷新问题*/
                if((to.name==from.name)&&(to.name=='mi_batch_create')){
                    if(this.componentName!='listPage'){
                        this.componentName = 'listPage';
                    }
                    this.$nextTick(()=>{
                        this.$refs[this.componentName].jumpToPage();
                    })
                }
            }
        },
        methods: {
            handleTabClick(active) {
                console.log(active.name,'mi');
                if (active.name === 'batch_v2') {
                    this.$router.push({path: '/marketing_management/mi_v2/mi_batch_v2_create'})
                }
            },
            getPageAllowAction() {
                let navId = this.$route.meta.pid;
                let navTabId = this.$route.meta.id;
                if (navId) {
                    HomeAPI.getPageAllowAction({
                        action_id: navId,
                    }).then(res=>{
                        this.isPageAllowed = true;

                        let resData = res.data || {};
                        let actionData = (resData.page_action || []).find(item => item.id == navTabId);
                        this.dimensionList = this._formatDataConfig(actionData.dimension);
                        this.pageFunc = actionData.func || [];
                        this.pageAction = resData.page_action || [];
                    },err=>{
                        this.isPageAllowed = false;
                        this.dimensionList = [];
                        this.pageFunc = [];
                        this.pageAction = [];
                    })
                }else{
                    this.isPageAllowed = false;
                    this.dimensionList = [];
                    this.pageFunc = [];
                }
            },
            _formatDataConfig(list) {
                let copyList = JSON.parse(JSON.stringify(list));
                return (copyList || []).map(item => {
                    let configStr = item.config || "{}";
                    item.config = JSON.parse(configStr.replace(/\r|\n/g, ' '));
                    if (item.children && item.children.length > 0) {
                        item.children = item.children.map(child => {
                            let configStr = child.config || "{}";
                            child.config = JSON.parse(configStr.replace(/\r|\n/g, ' '));
                            return child;
                        })
                    }
                    return item;
                });
            },
            handleChangePage(name,id, data = {}) {
                console.log(data);
                console.log('handleChangePage',name,id);
                this.actionItemId = id||'';
                this.componentName = name
                this.defaultCreteFormData = data
                this.$nextTick(()=>{
                    this.keepList = ['listPage'];
                })
                if(name=='listPage'||name=='infoPage'){
                    this.$nextTick(()=>{
                        if(name=='listPage'){
                            this.$refs[name].onSubmit();
                        }else{
                            this.$refs[name].startRefresh();
                        }
                    })
                }
            },
            clearAlive(){
                this.keepList = [];
            },
        }
    }

</script>

<style lang="scss" scoped>

    .tab-bar::after{
        content: '';
        position: absolute;
        left: -20px;
        right: -20px;
        background-color: #fff;
    }
    .tab-bar ::v-deep .el-tabs__header{
        background-color: #fff;
        margin-bottom: 10px;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    .tab-bar ::v-deep .el-tab-pane{
        margin: 0 15px;
    }

    .bg-wrap-color{
        padding: 0;
        background-color:#F1F4F9;
    }
    .bg-color{
        background-color: #fff;
    }
    .list-wrap{
        min-height: 100vh;
    }

</style>
